import { hexDecode, orchidDecryptBinary } from "./downloadOrchidDriveFilesBFS";

export async function orchidDecryptText(
  encryptedText: string,
  cipherKey: CryptoKey,
) {
  const encryptedData = hexDecode(encryptedText);
  const clearData = await orchidDecryptBinary(encryptedData, cipherKey);
  const enc = new TextDecoder();
  return enc.decode(clearData);
}
